import React from "react";
import PropTypes from "prop-types";

import { MaterialUIGridContainer } from "core/MaterialUI";

import {
    PromoGridItem,
    PromoBoxLink,
    IconContainer,
    Title,
    Description,
    LearnMore,
    LearnMoreIcons
} from "./styles";

const LearnMoreBox = ({ learnMoreContent }) => {
    if (typeof learnMoreContent === "string") {
        // if learnMoreContent is just text:
        return (
            <LearnMore>
                <p>{learnMoreContent}</p>
            </LearnMore>
        );
    } else {
        // if learnMoreContent is an array of SVG icons:
        return (
            <LearnMoreIcons>
                {learnMoreContent.map((learnMoreIcon, index) => {
                    const { icon } = learnMoreIcon;

                    return <React.Fragment key={index}>{icon}</React.Fragment>;
                })}
            </LearnMoreIcons>
        );
    }
};

const PromoBoxes = ({ content }) => {
    return (
        <MaterialUIGridContainer
            mobileMaxPadding={4}
            // passing in index 4 passes in the number "20" from the spacing array divided by 2 = 20px gutter as 10px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            tabletMaxPadding={4}
            // passing in index 4 passes in the number "20" from the spacing array divided by 2 = 20px gutter as 10px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            desktopMinPadding={4}
            // passing in index 4 passes in the number "20" from the spacing array divided by 2 = 20px gutter as 10px around each item (see line 9 of core/MaterialUI/ for this spacing array)
        >
            {content.map(promo => {
                const {
                    url,
                    iconName,
                    title,
                    description,
                    learnMoreContent
                } = promo;

                return (
                    <PromoGridItem item sm={12} md={6} lg={4} key={title}>
                        <PromoBoxLink href={url}>
                            <IconContainer>{iconName}</IconContainer>
                            <Title>{title}</Title>
                            <Description>{description}</Description>
                            <LearnMoreBox learnMoreContent={learnMoreContent} />
                        </PromoBoxLink>
                    </PromoGridItem>
                );
            })}
        </MaterialUIGridContainer>
    );
};

PromoBoxes.propTypes = {
    content: PropTypes.array.isRequired
};

export default PromoBoxes;
